<template>
    <div class="">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>

        <div class="row">
            <div class="d-none d-lg-block col-lg-2"></div>
            <div class="col-12 col-lg-8 ">
                <div class="accordion mb-3" id="accordion-filter-options">
                    <class-select ref="classSelect" @update="poll()"></class-select>
                    <worksheet-select ref="worksheetSelect"></worksheet-select>
                    
                    <grade-level-select ref="gradeLevelSelect" v-model="selected['grade_levels']"></grade-level-select>
                    <area-select ref="areaSelect" :gradeLevels="selected['grade_levels']"></area-select>
                    <strand-select ref="strandSelect"></strand-select>
                    <standard-select ref="standardSelect"></standard-select>
                </div>
                <div class="">
                    <button class="btn btn-primary" @click="new_sheet" :disabled="!newSheetReady"><i class="far fa-file-alt me-2"></i>Generate Checklist</button>
                    <button class="btn btn-primary" @click="reset"><i class="fas fa-sync-alt me-2"></i>Reset Form</button>
                </div>
            </div>
        </div>
    </div>
</template>
    
<style>
</style>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import GradeLevelSelect from './GradeLevelSelect.vue';
    import AreaSelect from './AreaSelect.vue';
    import StrandSelect from './StrandSelect.vue';
    import StandardSelect from './StandardSelect.vue';
    import ClassSelect from './ClassSelect.vue';
    import WorksheetSelect from './WorksheetSelect.vue';
    
    export default {
        name: 'Home',
        components: { Loading, AreaSelect, StrandSelect, StandardSelect, GradeLevelSelect, ClassSelect, WorksheetSelect },

        mounted() {
            this.poll();
        },

        methods: {
            poll: function() {
                return this.selected = {
                    grade_levels: this.$refs.gradeLevelSelect.selected.map(i => {
                        return i.grade;
                    }),
                    areas: this.$refs.areaSelect.selected.map(i => {
                        return i.id;
                    }),
                    strands: this.$refs.strandSelect.selected.map(i => {
                        return i.strand_hash;
                    }),
                    standards: this.$refs.standardSelect.selected,
                    class_id: this.$refs.classSelect.selected?.id,
                };
            },

            new_sheet: function() {
                this.selected = this.poll();
                window.location.assign(`/#/worksheet?class=${this.selected.class_id}&standards=${this.selected.standards}`);
            },

            reset: function() {
                this.$refs.gradeLevelSelect.clear();
                this.$refs.areaSelect.clear();
                this.$refs.strandSelect.clear();
                this.$refs.standardSelect.clear();
                this.poll();
            },
        },

        computed: {
            newSheetReady: function() {
                return Boolean(this.selected.class_id && this.selected.standards.length);
            }
        },

        data() {
            return {
                isLoading: false,
                
                selected: {
                    grade_levels: [],
                    areas: [],
                    strands: [],
                    standards: [],
                    class_id: null
                }
            }
        }
    }
</script>